/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_PerformanceInputs */

const en_svchip_performance = /** @type {(inputs: Svchip_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performance`)
};

const ar_svchip_performance = /** @type {(inputs: Svchip_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأداء`)
};

const bn_svchip_performance = /** @type {(inputs: Svchip_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পারফরম্যান্স`)
};

const de_svchip_performance = /** @type {(inputs: Svchip_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leistung`)
};

const es_svchip_performance = /** @type {(inputs: Svchip_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendimiento`)
};

const fr_svchip_performance = /** @type {(inputs: Svchip_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performances`)
};

const pt_svchip_performance = /** @type {(inputs: Svchip_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desempenho`)
};

const zh_svchip_performance = /** @type {(inputs: Svchip_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`性能`)
};

const tr_svchip_performance = /** @type {(inputs: Svchip_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performans`)
};

const ru_svchip_performance = /** @type {(inputs: Svchip_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Производительность`)
};

const pl_svchip_performance = /** @type {(inputs: Svchip_PerformanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydajność`)
};

/**
* | output |
* | --- |
* | "Performance" |
*
* @param {Svchip_PerformanceInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_performance = /** @type {((inputs?: Svchip_PerformanceInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_PerformanceInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_performance(inputs)
	if (locale === "bn") return bn_svchip_performance(inputs)
	if (locale === "de") return de_svchip_performance(inputs)
	if (locale === "es") return es_svchip_performance(inputs)
	if (locale === "fr") return fr_svchip_performance(inputs)
	if (locale === "pt") return pt_svchip_performance(inputs)
	if (locale === "zh") return zh_svchip_performance(inputs)
	if (locale === "tr") return tr_svchip_performance(inputs)
	if (locale === "ru") return ru_svchip_performance(inputs)
	if (locale === "pl") return pl_svchip_performance(inputs)
	return en_svchip_performance(inputs)
});